<template>
  <div class="airwallex_box">
    <div id="dropIn"
         :style="{ display: 'block' }" />
  </div>
</template>
        
        <script>
import { getSessionStorage, setSessionStorage } from '@/utils/stage'
import { createElement, loadAirwallex } from 'airwallex-payment-elements'
let n = 1
const onReady = (event) => {
  document.getElementById('loading').style.display = 'none'
  document.getElementById('dropIn').style.display = 'block'
  n++
  console.log(`Element is mounted: ${JSON.stringify(event.detail)}${n}`)
}
const onSuccess = (event) => {
  console.log(88888, event.detail)
}
const onError = (event) => {
  const { error } = event.detail
  document.getElementById('error').style.display = 'block' // Example: show error block
  document.getElementById('error').innerHTML = error.message // Example: set error message
  console.error('There was an error', error)
}
export default {
  name: 'DropIn',
  created() {},
  mounted() {
    loadAirwallex({
      env: 'demo',
      origin: window.location.origin,
    }).then(() => {
      this.init()
    })
    if (this.btn == 0) {
      const domElement = document.getElementById('dropIn')
      domElement.addEventListener('onReady', onReady)
      domElement.addEventListener('onSuccess', onSuccess)
      domElement.addEventListener('onError', onError)
    }
  },
  beforeDestroy() {
    // const domElement = document.getElementById('dropIn')
    // // Be sure to clean up event listeners when component unmounts
    // if (domElement) {
    //   console.log(898989898989890)
    //   domElement.removeEventListener('onReady', onReady)
    //   domElement.removeEventListener('onSuccess', onSuccess)
    //   domElement.removeEventListener('onError', onError)
    // }
  },
  methods: {
    init() {
      console.log(this.$router.query)
      let methods = ['card']
      if (id == 1 || id == 0) {
        methods = ['card']
      } else if (id == 2) {
        methods = ['konbini']
      } else {
        methods = ['payeasy']
      }
      const airwallexData = JSON.parse(getSessionStorage('airwallexData'))
      console.log('airwallexData', airwallexData)
      const intent_id = airwallexData ? airwallexData.payment_intent_id : ''
      const client_secret = airwallexData ? airwallexData.client_secret : ''
      const currency = 'JPY'
      const element = createElement('dropIn', {
        intent_id,
        client_secret,
        currency,
        methods,
      })
      element.mount('dropIn')
    },
  },
}
</script>
        
        <style>
/* Custom styling for the element */
.airwallex_box {
  width: 700px;
  background: rgb(255, 255, 255);
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  box-sizing: border-box;
}
#dropIn {
  width: 540px;
  margin: 48px auto;
}
</style>